import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("input", {
    type: "text",
    class: "form-control ps-10 w-200px mt-1 form-control-sm",
    style: {"height":"1em"},
    placeholder: `Search`,
    id: "searchTableInput",
    onKeyup: _cache[0] || (_cache[0] = ($event: any) => (_ctx.searchTable(_ctx.tableIdName)))
  }, null, 32))
}